export const hamburger = 'M4,20V51H253V20Zm0,93v31H253V113Zm0,92v31H253V205Z'
